import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Handle chunk load failures (stale cached bundles after deploy)
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Loading CSS chunk') ||
    event.message?.includes('Failed to fetch dynamically imported module')
  ) {
    // Clear caches and reload once
    const reloaded = sessionStorage.getItem('chunk_reload');
    if (!reloaded) {
      sessionStorage.setItem('chunk_reload', '1');
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
